export default __webpack_public_path__ + "static/media/abonnement.90cfe113.png";